export default {"src":"/_next/static/media/ventiq_Logo_Design_V1.fef76c70.svg","height":64,"width":251,"blurWidth":0,"blurHeight":0};